import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../../../hooks/usePageTitle';
import SEOHead from '../../../components/base/SEOHead';

// 导入HTML内容
import jiajuHtml from './jiaju.html?raw';

export default function SimpleArticle() {
    usePageTitle('家居出海营销策略指南');

    // 定义文章元数据
    const articleMeta = {
        title: "家居出海营销策略指南",
        author: "Koluno内容团队",
        publishDate: "2025-12-01",
        readTime: "8分钟阅读"
    };

    // SEO数据
    const seoData = {
        title: `${articleMeta.title} - Koluno`,
        description: `了解家居产品出海营销策略，由${articleMeta.author}撰写，发布于${new Date(articleMeta.publishDate).toLocaleDateString('zh-CN')}`,
        keywords: '家居,出海营销,跨境电商,达人合作,营销策略',
        ogTitle: articleMeta.title,
        ogDescription: `了解家居产品出海营销策略，由${articleMeta.author}撰写`,
        ogUrl: `${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/articles/jiaju`,
    };

    // 结构化数据
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": articleMeta.title,
        "author": {
            "@type": "Organization",
            "name": articleMeta.author
        },
        "datePublished": articleMeta.publishDate,
        "description": `了解家居产品出海营销策略，由${articleMeta.author}撰写`,
        "publisher": {
            "@type": "Organization",
            "name": "Koluno",
            "logo": {
                "@type": "ImageObject",
                "url": `${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/logo.png`
            }
        }
    };

    return (
        <div className="min-h-screen flex flex-col">
            <SEOHead {...seoData} structuredData={structuredData} />
            <Header />

            <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-4xl pt-20">
                <article className="prose prose-lg lg:prose-xl max-w-none">
                    {/* 返回文章列表按钮 */}
                    <div className="mb-8">
                        <Link
                            to="/articles"
                            className="inline-flex items-center text-purple-600 hover:text-purple-800 transition-colors duration-200 font-medium"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                            </svg>
                            返回文章列表
                        </Link>
                    </div>

                    {/* 文章元信息区域 */}
                    <header className="mb-10 pb-8 border-b border-gray-200 bg-white rounded-lg shadow-sm p-6">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                            {articleMeta.title}
                        </h1>

                        <div className="flex flex-wrap items-center gap-6 text-gray-600">
                            <div className="flex items-center bg-gray-50 px-3 py-1 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                </svg>
                                <span className="font-medium">{articleMeta.author}</span>
                            </div>

                            <div className="flex items-center bg-gray-50 px-3 py-1 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                </svg>
                                <time dateTime={articleMeta.publishDate} className="font-medium">
                                    {new Date(articleMeta.publishDate).toLocaleDateString('zh-CN', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </time>
                            </div>

                            <div className="flex items-center bg-gray-50 px-3 py-1 rounded-full">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                </svg>
                                <span>{articleMeta.readTime}</span>
                            </div>
                        </div>
                    </header>

                    {/* 文章内容 */}
                    <div
                        className="article-content leading-relaxed text-gray-700"
                        dangerouslySetInnerHTML={{ __html: jiajuHtml }}
                    />

                    {/* 底部返回按钮 */}
                    <div className="mt-16 pt-8 border-t border-gray-200">
                        <Link
                            to="/articles"
                            className="inline-flex items-center text-purple-600 hover:text-purple-800 transition-colors duration-200 font-medium"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                            </svg>
                            返回文章列表
                        </Link>
                    </div>
                </article>
            </main>

            <Footer />
        </div>
    );
}
